'use strict';

var React = require('react'),
    Group = require('../organisms/Group'),
    SidebarBody = require('../organisms/SidebarBody'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    UserSubscribersStore = require('../stores/UserSubscribersStore'),
    UserActionCreators = require('../actions/UserActionCreators'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    UserStore = require('../stores/UserStore'),
    EmptyState = require('../molecules/EmptyState'),
    FollowUserButton = require('../molecules/FollowUserButton'),
    { PropTypes } = React;

var UserSubscribers = React.createClass({
  mixins: [createStoreMixin(UserSubscribersStore, UserStore), PureRenderMixin],

  propTypes: {
    userId: PropTypes.number.isRequired
  },

  getStateFromStores(props) {
    return {
      user: UserStore.get(props.userId),
      userSubscribers: UserSubscribersStore.getUserSubscribers(props.userId),
      isMe: UserStore.isMe(props.userId)
    };
  },

  componentDidMount() {
    UserActionCreators.requestUserSubscriberPage(this.props.userId, true, true);
  },

  render: function () {
    var { userId } = this.props,
        { user, userSubscribers, isMe } = this.state,
        firstName = user.name.split(' ')[0],
        title = isMe ? 'You Are Followed By' : `${firstName} Is Followed By`,
        emptyLabel = isMe ? 'You have no followers.' : `${firstName} has no followers.`;

    return (
      <SidebarBody title={title}>
        <Group type='users'
               items={userSubscribers}
               itemProps={{
                 size: 'small',
                 imageSize: 'large',
                 showLocation: true,
                 showAbout: true,
                 showFollow: true
               }}
               context='sidebar'
               mode='grid'
               columns={2}
               isExpectingPage={UserSubscribersStore.isExpectingPage(userId)}
               isLastPage={UserSubscribersStore.isLastPage(userId)}
               isInvalidated={UserSubscribersStore.isInvalidated(userId)}
               loadNextPage={this.requestNextPage}>
          <EmptyState label={emptyLabel}
                      absoluteCenter>
            {!isMe && <FollowUserButton user={user} />}
          </EmptyState>
        </Group>
      </SidebarBody>
    );
  },

  requestNextPage() {
    UserActionCreators.requestUserSubscriberPage(this.props.userId);
  }
});

module.exports = UserSubscribers;



/** WEBPACK FOOTER **
 ** ./sidebar/UserSubscribers.jsx
 **/